<template>
    <div class="register-grid-page">
        <NavBarPP>
            <template v-slot:right-buttons v-if="getRegistrationFlowStatus.includes(1)">
                <span class="navbar-text">
                    <router-link type="button" to="/plataforma">
                        <button type="button" :class="`btn btn-${getIsDarkTheme ? 'light' : 'dark'}`">
                            Acessar plataforma
                        </button>
                    </router-link>
                </span>
            </template>
        </NavBarPP>

        <div class="id-progress-bar">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2>Cadastro</h2>
                    </div>

                    <div class="col-md-6">
                        <b-progress>
                            <b-progress-bar
                                :value="getProgress"
                                :label="`${getProgress}%`"
                                :variant="getProgressBarColor"
                            ></b-progress-bar>
                        </b-progress>

                        <b-alert show dismissible variant="success" v-if="getShowGamificationProgress">
                            {{ getProgressMessage }}
                        </b-alert>
                    </div>
                </div>
            </div>
        </div>
        <!-- changeRegisterForm -->

        <div class="content-items-form registration-flow-panel">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4 padding-0">
                        <div class="left-content">
                            <b-form-group>
                                <b-form-checkbox-group v-model="getRegistrationFlowStatus" name="flavour-1">
                                    <b-form-checkbox
                                        class="link-item"
                                        :class="{ hidden: option.item === 2 }"
                                        :value="option.value"
                                        :disabled="option.disabled"
                                        v-for="(option, index) in optionsStatus"
                                        :key="index"
                                        @click.native="itemFlowOnClick(option.value, index)"
                                    >
                                        {{ option.text }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="col-12 col-md-8 padding-0">
                        <div class="right-content">
                            <router-view :key="$route.path">
                                <template v-slot:how-register-modal>
                                    <div class="help-message" @click="showModal('modal-ref')">
                                        <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt="" />
                                        <div class="text">
                                            Como preencher meu cadastro
                                        </div>
                                    </div>
                                </template>
                            </router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DangerModalPP ref="warningModal" :message="messageModal" />

        <b-modal
            ref="modal-ref"
            :title="worksRegisterModal.title"
            body-class="how-register-body-modal"
            ok-only
            ok-title="Fechar"
            ok-variant="secondary"
            size="lg"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content" v-for="(item, index) in worksRegisterModal.items" :key="index">
                <div class="text" v-html="item.text"></div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import NavBarPP from '@/ui/navbar-pp/NavBarPP'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { RegisterFirstInformationApi } from '../../../api/register-first-information/'

const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { NavBarPP, DangerMsgModal, DangerModalPP },
    data() {
        return {
            currentRouterName: 'FirstInformationForm1',
            messageModal: null,
            optionsStatus: [
                {
                    text: 'Primeiras informações',
                    item: 1,
                    value: 1,
                    disabled: true,
                    routeName: 'FirstInformationForm1'
                },
                {
                    text: 'Sobre o Responsável Legal',
                    item: 2,
                    value: 2,
                    disabled: true,
                    routeName: 'AboutLegalGuardianForm1'
                },
                { text: 'Sobre a iniciativa', item: 3, value: 3, disabled: true, routeName: 'AboutInitiativeForm1' },
                {
                    text: 'Planejamento e Gestão',
                    item: 4,
                    value: 4,
                    disabled: true,
                    routeName: 'ManagementPlanningForm1'
                },
                {
                    text: 'Sustentabilidade Financeira',
                    item: 5,
                    value: 5,
                    disabled: true,
                    routeName: 'FinancialSustainabilityForm1'
                },
                { text: 'Redes e Parceiros', item: 6, value: 6, disabled: true, routeName: 'NetworksPartnersForm1' },
                { text: 'Resultados e Impactos', item: 7, value: 7, disabled: true, routeName: 'ResultsImpactsForm1' },
                { text: 'Governança', item: 8, value: 8, disabled: true, routeName: 'GovernanceForm1' },
                { text: 'Anexos', item: 9, value: 9, disabled: true, routeName: 'AttachmentsForm1' }
            ],
            worksRegisterModal: {
                title: 'Como preencher meu cadastro',
                items: [
                    {
                        text: `Os cadastro na plataforma é totalmente gratuito, onde as informações sobre sua iniciativa, projeto, negócio ou organização são fundamentais para estimular possíveis conexões, matchs e outros benefícios. Suas informações separadas em blocos temáticos são
                        armazenadas de forma segura, você também tem o controle sobre o que pode ser exibido no seu perfil público.`
                    },
                    {
                        text: `Quanto mais completo for seu cadastro maiores são as chances de ser encontrado por um possível parceiro.`
                    },
                    {
                        text: `Saiba o que é necessário para efetuar o cadastro na Plataforma Potências Periféricas.`
                    },
                    {
                        text: `<h5>CADASTRO</h5>`
                    },
                    {
                        text: `<strong>Cadastro como Potência Periférica</strong>`
                    },
                    {
                        text: `As potências são divididas em 2 grupos: <li>Potências - podem ou não ter CNPJ e desenvolvem atividades de natureza assistencial, de advocacy, de formação e pesquisa, dentre outros.</li>
                    <li>Prestadores de serviço - precisam ter CNPJ e vendem produtos ou prestam serviços</li>`
                    },
                    {
                        text: `Cadastro como Investidor`
                    },
                    {
                        text: `Um(a) Investidor(a) é uma pessoa física ou jurídica que apoia potências seja financeiramente, ou com outras formas de doação, apoio em pesquisas, consultorias, aceleração, capacitação, entre outros.`
                    },
                    {
                        text: `PREENCHIMENTO`
                    },
                    {
                        text: `O preenchimento do cadastro está dividido em 8 blocos:
                    <li>Primeiras Informações</li>
                    <li>Sobre a Iniciativa</li>
                    <li>Planejamento e Gestão</li>
                    <li>Sustentabilidade Financeira</li>
                    <li>Redes e Parceiros</li>
                    <li>Resultados e Impactos</li>
                    <li>Governança</li>
                    <li>Anexos</li>`
                    },
                    {
                        text: `Sabemos que o cadastro é longo, mas não se assustem, NÃO é necessário preencher tudo de uma vez. Você pode preencher cada bloco quando quiser. No entanto, é necessário preenchê-los na ordem em que aparecem. Por exemplo, ao terminar o bloco Primeiras Informações o que vem a seguir é Sobre a Iniciativas. Se ao terminar o Primeiras Informações você desejar preencher o Redes e Parceiros, por exemplo, isso não será possível.`
                    },
                    {
                        text: `O cadastro é dividido em blocos com níveis diferentes de detalhamento. Com essas informações poderemos:
                    <li>trazer transparência para o trabalho de cada um</li>
                    <li>aumentar a confiança para estabelecer conexões entre iniciativas</li>
                    <li>oferecer uma gama de mais de 50 tipos de filtro para que você encontre com facilidade uma iniciativa com as características que você busca!</li>`
                    },
                    {
                        text: `Ao preencher o cadastro você perceberá que existem dois símbolos em algumas das perguntas: cadeado e asterisco`
                    },
                    {
                        text: `<h5>CADEADO</h5>`
                    },
                    {
                        text: `Nas perguntas que contém um cadeado, você tem a opção de permitir que outros vejam a resposta que inseriu.`
                    },
                    {
                        text: `Disponibilizamos essa opção, pois cuidamos dos seus dados e seguimos a Lei Geral de Proteção de Dados Pessoais - LGPD. Dessa maneira, para informações sensíveis, você terá a possibilidade de deixá-las públicas ou privadas:`
                    },
                    {
                        text: `Todos (as) que acessarem a plataforma poderão ver essa informação.`
                    },
                    {
                        text: `<img src="../../../public/static/img/publico.png" width="80px"/> Todos (as) que acessarem a plataforma poderão ver essa informação.`
                    },
                    {
                        text: `<img src="../../../public/static/img/privado.png" width="80px"/> Somente você e os administradores da plataforma terão acesso à essa informação. Mas, apesar de não estar visível, ela contribuirá para as estatísticas e acompanhamento da plataforma.`
                    },
                    {
                        text: `<h5>ASTERISCO VERMELHO</h5>`
                    },
                    {
                        text: `O asterisco vermelho indica que é necessário responder a pergunta com essa marcação para poder seguir adiante. Caso você deixe uma pergunta com * em branco, não conseguirá avançar.`
                    }
                ]
            }
        }
    },
    methods: {
        ...mapActions(['changeProfileId', 'setIsLoading', 'setProgress', 'setCurrentFormPlatform']),
        fetch() {
            const currentRouterNameTemp = this.$router.history.current.name

            if (Object.keys(localStorage).includes('usuario')) {
                this.setIsLoading(true)
                registerFirstInformationApi
                    .listFirst()
                    .then(res => {
                        this.setProgress(res.data.percentual)
                        this.changeProfileId({
                            idOrganizacao: res.data.id_organizacao,
                            prestadorServico: res.data.prestador_servico
                        })

                        this.setCurrentRouterName()
                        this.updateRegistrationFlow(this.currentRouterName)

                        if (currentRouterNameTemp !== this.currentRouterName) {
                            this.$router.push({ name: this.currentRouterName })
                        }
                    })
                    .catch(error => {
                        this.messageModal = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        updateRegistrationFlow(routerName) {
            let currentItem = 0
            switch (routerName) {
                case 'FirstInformationForm1':
                case 'FirstInformationForm2':
                case 'FirstInformationForm3':
                    currentItem = 0
                    break

                // case 'AboutLegalGuardianForm1':
                // case 'AboutLegalGuardianForm2':
                // case 'AboutLegalGuardianForm3':
                //     currentItem = 1
                //     break

                case 'AboutInitiativeForm1':
                case 'AboutInitiativeForm2':
                case 'AboutInitiativeForm3':
                case 'AboutInitiativeForm4':
                case 'AboutInitiativeForm5':
                case 'AboutInitiativeForm6':
                case 'AboutInitiativeForm7':
                case 'AboutInitiativeForm8':
                case 'AboutInitiativeForm9':
                case 'AboutInitiativeForm10':
                case 'AboutInitiativeForm11':
                case 'AboutInitiativeForm12':
                case 'AboutInitiativeForm13':
                case 'AboutInitiativeForm14':
                    currentItem = 2
                    break

                case 'ManagementPlanningForm1':
                case 'ManagementPlanningForm2':
                    currentItem = 3
                    break

                case 'FinancialSustainabilityForm1':
                    currentItem = 4
                    break

                case 'NetworksPartnersForm1':
                    currentItem = 5
                    break

                case 'ResultsImpactsForm1':
                    currentItem = 6
                    break

                case 'GovernanceForm1':
                case 'GovernanceForm2':
                case 'GovernanceForm3':
                case 'GovernanceForm4':
                case 'GovernanceForm5':
                case 'GovernanceForm6':
                case 'GovernanceForm7':
                case 'GovernanceForm8':
                case 'GovernanceForm9':
                case 'GovernanceForm10':
                    currentItem = 7
                    break

                case 'AttachmentsForm1':
                    currentItem = 8
                    break

                default:
                    break
            }

            if (document.querySelectorAll('.custom-checkbox.current').length) {
                document.querySelectorAll('.custom-checkbox.current')[0].classList.remove('current')
            }

            document.querySelectorAll('.custom-checkbox')[currentItem].classList.add('current')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('app')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        itemFlowOnClick(value, indexItem) {
            if (this.getRegistrationFlowStatus.includes(value)) {
                const routeName = this.optionsStatus[indexItem].routeName
                this.$router.push({ name: routeName })
                this.scrollBehavior()
            }
        },
        setCurrentRouterName() {
            if (Number(this.getProgress) === 100) {
                this.currentRouterName = 'AttachmentsForm1'
            } else if (Number(this.getProgress) >= 96.95) {
                this.currentRouterName = 'AttachmentsForm1'
            } else if (Number(this.getProgress) >= 69.25) {
                this.currentRouterName = 'GovernanceForm1'
            } else if (Number(this.getProgress) >= 66.48) {
                this.currentRouterName = 'ResultsImpactsForm1'
            } else if (Number(this.getProgress) >= 63.71) {
                this.currentRouterName = 'NetworksPartnersForm1'
            } else if (Number(this.getProgress) >= 60.94) {
                this.currentRouterName = 'FinancialSustainabilityForm1'
            } else if (Number(this.getProgress) >= 55.4) {
                this.currentRouterName = 'ManagementPlanningForm1'
            } else if (Number(this.getProgress) >= (this.getProfileId === 3 ? 16.62 : 13.85)) {
                this.currentRouterName = 'AboutInitiativeForm1'
            } else if (Number(this.getProgress) >= 8.31) {
                this.currentRouterName = 'AboutInitiativeForm1'
            }
        }
    },
    computed: {
        getProgressBarColor() {
            const value = this.getProgress
            return value < 10 ? 'danger' : value >= 10 && value < 50 ? 'warning' : 'success'
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getProgress() {
            return this.$store.state.progress
        },
        getRegistrationFlowStatus() {
            if (Number(this.getProgress) === 100) {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9]
            } else if (Number(this.getProgress) >= 96.95) {
                return [1, 2, 3, 4, 5, 6, 7, 8]
            } else if (Number(this.getProgress) >= 69.25) {
                return [1, 2, 3, 4, 5, 6, 7]
            } else if (Number(this.getProgress) >= 66.48) {
                return [1, 2, 3, 4, 5, 6]
            } else if (Number(this.getProgress) >= 63.71) {
                return [1, 2, 3, 4, 5]
            } else if (Number(this.getProgress) >= 60.94) {
                return [1, 2, 3, 4]
            } else if (Number(this.getProgress) >= 55.4) {
                return [1, 2, 3]
            } else if (Number(this.getProgress) >= (this.getProfileId === 3 ? 16.62 : 13.85)) {
                return [1, 2]
            } else if (Number(this.getProgress) >= 8.31) {
                return [1]
            }

            return []
        },
        getProgressMessage() {
            let message = ''

            switch (this.getProgress) {
                case '8.31':
                    message =
                        '10%: Salve, com essas primeiras informações preenchidas, você já consegue visualizar quem está na plataforma. #faltapouco para começar as interações (8.31)'
                    break

                case '19.39':
                    message =
                        '20%: Hey, obrigado por compartilhar seus perfis e redes sociais. Agora os outros usuários poderão conhecer melhor suas atividades. (19.39)'
                    break

                case '30.47':
                    message =
                        '30%: Essas informações que acabou de nos passar são de extrema importância para conseguirmos fazer o matching perfeito. (30.47)'
                    break

                case '41.55':
                    message =
                        '40%: Estamos quase lá, `o´. Esses dados, irão nos ajudar a promover indicações e movimentar a diversidade e economia das periferias. (41.55)'
                    break

                case '55.40':
                    message =
                        '50%: Olha só, agora você já conseguirá se conectar! #faltapouco para conseguir mandar mensagens. #continue (55.40)'
                    break

                case '60.94':
                    message =
                        '60%:Aeee, agora você já está conectado e conseguindo mandar mensagens. Desbloqueando a próxima ação você conseguirá enviar convidar seus parças que ainda não estão na plataforma (60.94)'
                    break

                case '72.02':
                    message =
                        '70%: Aeee, agora você já está conectado, enviando mensagens e convites. Falta pouco para conseguir receber e fazer recomendações sobre os usuários.  (72.02)'
                    break

                case '80.33':
                    message =
                        '80%: Massa que você chegou até aqui. Agora já tem mais da metade da plataforma liberada, continue preenchendo para conseguir exportar relatórios das suas atividades. (80.33)'
                    break

                case '91.41':
                    message =
                        '90%: Olha só, agora você já consegue exportar os relatórios das suas atividades na plataforma! #continue preenchendo para conseguir (91.41)'
                    break

                case '96.95':
                    message =
                        '100%: Parabéns, você desbloqueou a última ação da plataforma `O´. E Aí, valeu a pena né? Nessa última seção você vai conseguir  inserir anexos na plataforma que julga como importante para sua organização. (96.95)'
                    break

                default:
                    message = ''
                    break
            }

            return message
        },
        getShowGamificationProgress() {
            return this.$store.state.showGamificationProgress
        }
    },
    updated() {
        const newRouterName = this.$router.history.current.name
        if (newRouterName !== this.currentRouterName) {
            this.currentRouterName = newRouterName
            this.updateRegistrationFlow(newRouterName)
        }
    },
    mounted() {
        this.fetch()
    }
}
</script>

<style scope src="./RegisterGridPage-light-theme.css"></style>
<style scope src="./RegisterGridPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/register-grid-page/RegisterGridPage.vue